import { useCallback, useEffect, useState } from "react";

import siteService from "../siteService";
import { AxiosResponse } from "axios";
import { ISite } from "../site.interface";

const useGetSiteBySlug = (slug: string) => {
  const [data, setData] = useState<AxiosResponse<ISite>>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");

  const callApi = useCallback(() => {
    return siteService.getBySlug(slug);
  }, []);

  const transformResponse = useCallback((response: AxiosResponse<ISite>) => {
    if (response) {
      setData(response);
    }
  }, []);

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callApi();
      transformResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await callApi();
        transformResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { data, error, isLoading, refetch };
};

export default useGetSiteBySlug;
